<template>
  <div>
    <b-modal
      id="modal-manual-rki"
      ref="modal-manual-rki"
      centered
      :title="$t('DEBTIA_MANUAL_RKI_REGISTRATION')"
      :ok-title="$t('Register')"
      :no-close-on-backdrop="true"
      cancel-variant="outline-secondary"
      size="md"
      :ok-disabled="loader"
      @ok="submitHandler"
      @show="resetModal"
      @hidden="resetModal"
    >
      <b-overlay
        id="overlay-background"
        :show="loader"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-alert
          variant="warning"
          show
        >
          <div class="alert-body">
            <span>
              {{ $t('DEBITA_RKI_ALERT_MSG') }}</span>
          </div>
        </b-alert>
        <b-alert
          v-if="errorMsg"
          variant="warning"
          show
        >
          <h4
            v-if="errorMsg"
            class="alert-heading"
          >
            {{ $t('DEBITA_ERROR') }}
          </h4>
          <div class="alert-body">
            <span v-if="errorMsg">{{ errorMsg }}</span>
          </div>
        </b-alert>
        <div>
          <b-overlay
            :show="!debtors && debtors.length === 0"
            variant="dark"
            opacity="0.85"
            blur="2px"
            rounded="sm"
            spinner-variant="primary"
            spinner-medium
          >
            <b-card
              class="border border-white"
            >
              <div class="d-flex justify-content-between">
                <label for="">{{ $t('DEBTIA_SELECT_DEBTORS') }}</label>
                <b-form-checkbox
                  v-model="selectAll"
                  switch
                  @change="toggleSelectAll"
                >
                  {{ selectAll ? $t('DEBTIA_DESELECT_ALL') : $t('DEBTIA_SELECT_ALL') }}
                </b-form-checkbox>
              </div>
              <div>
                <b-list-group
                  v-for="debtor in filteredDebtors"
                  :key="debtor.id"
                  class="mb-1"
                >
                  <b-list-group-item class="d-flex align-items-center">
                    <b-form-checkbox
                      v-model="selectedDebtors"
                      :value="debtor.id"
                      class="mr-2"
                    />
                    {{ debtor.name }}
                  </b-list-group-item>
                </b-list-group>
              </div>

            </b-card>
          </b-overlay>
        </div>
        <div>
          <form
            ref="rkiRegistrationForm"
          >
            <validation-observer
              ref="rkiRegistrationRules"
              tag="form"
            >
              <b-row>
                <b-col md="12">
                  <validation-provider
                    #default="{ errors }"
                    name="Fundament Kode"
                    rules="required"
                  >
                    <b-form-group
                      label="Fundament Kode"
                      label-for="send-by"
                      :state="errors.length > 0 ? false:null"
                    >
                      <v-select
                        v-model="fundamentKode"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="fundamentKodeOptions"
                        :reduce="val => val.value"
                        :clearable="false"
                        input-id="awaitType"
                      />
                      <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="12">
                  <validation-provider
                    #default="{ errors }"
                    name="Fundament Dato"
                    rules="required"
                  >
                    <b-form-group
                      label="Fundament Dato"
                      label-for="email"
                      :state="errors.length > 0 ? false:null"
                    >
                      <b-form-datepicker
                        v-if="fundamentKode === '0'"
                        id="datepicker-dateformat2"
                        v-model="fundamentDato"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        :max="zeroMaxDate"
                        :min="zeroMinDate"
                        locale="da"
                      />
                      <b-form-datepicker
                        v-else
                        id="datepicker-dateformat2"
                        v-model="fundamentDato"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        :max="maxDate"
                        locale="da"
                      />
                      <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col
                  v-if="fundamentKode !== '0'"
                  md="12"
                >
                  <validation-provider
                    v-slot="{ validate, errors }"
                    name="File"
                    rules="required"
                  >
                    <b-form-group
                      label="Fundament Fil"
                      label-for="fil"
                      :state="errors.length > 0 ? false:null"
                    >
                      <b-form-file
                        id="fil"
                        ref="button-file"
                        v-model="file"
                        @change="validate($event)"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
              </b-row>
            </validation-observer>
          </form>
        </div>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal, BFormGroup, BFormCheckbox, BRow, BCol, BFormInvalidFeedback, BFormFile, BFormDatepicker, BCard, BListGroup, BListGroupItem, BOverlay, BAlert,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import axios from '@axios'
import { EventBus } from '@/event-bus'
import i18n from '@/libs/i18n'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  components: {
    BModal,
    BFormGroup,
    BFormCheckbox,
    BFormDatepicker,
    BRow,
    BCol,
    BFormInvalidFeedback,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BFormFile,
    BCard,
    BListGroup,
    BListGroupItem,
    BOverlay,
    BAlert,
  },
  directives: {
    Ripple,
  },
  props: {
    debtors: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedDebtors: [],
      selectAll: false,
      fundamentKode: null,
      fundamentDato: null,
      maxDate: this.formatDate(new Date()),
      zeroMaxDate: this.zeroMaxFormatDate(new Date()),
      zeroMinDate: this.zeroMinFormatDate(new Date()),
      required,
      file: null,
      caseID: this.$route.params.id,
      loader: false,
      errorMsg: null,
      fundamentKodeOptions: [
        { label: 'A - Betalingspåkrav 1. Påtegning', value: 'A' },
        { label: 'B - Betalingspåkrav 2. Påtegning', value: 'B' },
        { label: 'C - Stævning', value: 'C' },
        { label: 'D - Fogedsag, fremlagt og opgjort', value: 'D' },
        { label: 'E - Dom', value: 'E' },
        { label: 'F - Insolvenserklæring I anden sag', value: 'F' },
        { label: 'I - Konkurs', value: 'I' },
        { label: 'K - Tvangsakkord indledt', value: 'K' },
        { label: 'L - Retsforlig', value: 'L' },
        { label: 'P - Fogedretsrekvisation', value: 'P' },
        { label: 'S - Offentlig indberetning', value: 'S' },
        { label: 'T - Tvangsauktion (fordring opgjort)', value: 'T' },
        { label: 'U - Tvangsauktion (udlæg)', value: 'U' },
        { label: 'W - Gældssanering, indledt', value: 'W' },
        { label: 'Y - Skyldnerklæring', value: 'Y' },
        { label: 'Z - Frivilligt forlig', value: 'Z' },
        { label: '0 - Intet fundament', value: '0' },
      ],
    }
  },
  computed: {
    filteredDebtors() {
      return this.debtors.filter(debtor => debtor.can_manually_enter === true)
    },
  },
  watch: {
    fundamentKode: {
      handler() {
        this.fundamentDato = null
      },
    },
    selectedDebtors: {
      handler(newVal) {
        if (newVal.length === this.filteredDebtors.length) {
          this.selectAll = true
        } else {
          this.selectAll = false
        }
      },
      deep: true,
    },
  },
  methods: {
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedDebtors = this.filteredDebtors.map(debtor => debtor.id)
      } else {
        this.selectedDebtors = []
      }
    },
    submitHandler(e) {
      e.preventDefault()
      this.$refs.rkiRegistrationRules.validate().then(success => {
        if (!success) return
        this.$swal({
          title: i18n.t('DEBTIA_CAUTION'),
          text: i18n.t('DEBTIA_CONFIRMED_RKI_REGISTRATION_MSG'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: i18n.t('DEBTIA_YES'),
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            this.confirmedRKIRegistration()
          }
        })
      })
    },
    confirmedRKIRegistration() {
      this.loader = true
      const form = new FormData()
      form.append('fundament_code', this.fundamentKode)
      form.append('fundament_date', this.fundamentDato)
      form.append('fundament_file', this.file || '')
      form.append('case_id', this.caseID)
      this.selectedDebtors.forEach((debtor, index) => {
        form.append(`debtors[${index}]`, debtor)
      })
      axios.post('/rki/manual-entry', form)
        .then(response => {
          if (response.status === 200) {
            this.$refs['modal-manual-rki'].hide()
            EventBus.$emit('refreshDebtorsSection')
          }
        })
        .catch(err => {
          if (err.response?.data?.message) {
            this.loader = false
            this.errorMsg = Array.isArray(err.response.data.message)
              ? err.response.data.message[0]
              : err.response.data.message
          }
        })
        .finally(() => {
          this.loader = false
        })
    },
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    zeroMinFormatDate(date) {
      date.setDate(date.getDate() - 15)
      date.setFullYear(date.getFullYear() - 1)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0') // Months are zero-indexed
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    zeroMaxFormatDate(date) {
      date.setDate(date.getDate() - 15)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0') // Months are zero-indexed
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    resetModal() {
      this.fundamentKode = null
      this.fundamentDato = null
      this.file = null
      this.errorMsg = null
      this.loader = false
      this.selectedDebtors = []
      this.selectAll = false
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

</style>
